export function PostsPageHeader() {
  return (
    <div className="pt-24 sm:pt-32 pb-8 sm:pb-10 border-b border-[#E8E0D5]">
      <div className="max-w-2xl mx-auto px-4 sm:px-6">
        <p
          className="text-xs font-semibold tracking-widest uppercase text-[#5B7B6F] mb-3"
          style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
        >
          Articles
        </p>
        <h1
          className="text-2xl sm:text-3xl font-bold text-[#2C2416] mb-3 leading-snug"
          style={{ fontFamily: "'Noto Serif JP', 'Georgia', serif", letterSpacing: '-0.01em' }}
        >
          記事一覧
        </h1>
        <p
          className="text-sm text-[#7A6E62] leading-relaxed"
          style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
        >
          AIツール活用、UI再現、制作フロー、仕様整理などの記事をまとめています。<br className="hidden sm:block" />
          実際に作って、詰まって、直したところまで残す実践メディアです。
        </p>
      </div>
    </div>
  );
}
